import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 no-underline"
          >
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-play-circle-fill text-background-50 text-xl w-5 h-5 flex items-center justify-center"></i>
            </div>
            <span className="text-lg font-heading font-bold whitespace-nowrap hidden sm:block">
              精品视频精选
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap flex items-center gap-1 cursor-pointer">
                分类浏览
                <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center"></i>
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-background-50 border border-background-200/70 rounded-lg p-2 shadow-lg min-w-[200px]">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-3 py-2.5 rounded-md hover:bg-background-100 text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
                    >
                      <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <button
              className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-foreground-700 w-4 h-4 flex items-center justify-center"></i>
            </button>
            <button
              className="md:hidden w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center hover:bg-background-200 transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="菜单"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-700 w-5 h-5 flex items-center justify-center`}></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden border-t border-background-200/70 bg-background-50 py-3">
            <div className="max-w-7xl mx-auto px-4 flex flex-col gap-1">
              <Link
                to="/"
                className="px-3 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors"
              >
                首页
              </Link>
              <div className="px-3 py-2 text-xs font-medium text-foreground-400 uppercase tracking-wider">分类浏览</div>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-3 px-3 py-2.5 rounded-md hover:bg-background-100 text-sm text-foreground-700 hover:text-primary-500 transition-colors"
                >
                  <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className="px-3 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors"
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}